import React, { Fragment } from "react";
// import { Link } from "react-router-dom";
const Pagination2 = ({
  booksPerPage,
  totalBooks,
  firstPage,
  lastPage,
  loading,
  currentPage,
  paginate,
  prevPage,
  nextPage,
}) => {
  const pageNumbers = [];

  // lastPage =40
  
  if (lastPage > 20) {
    for (let i = firstPage; i <= 10; i++) {
      if(currentPage==10 && i==10){
        pageNumbers.push(i);
        pageNumbers.push(i+1);
      }
      else{
        pageNumbers.push(i);
      }
    }
    if(currentPage > 10 && currentPage<lastPage-10){
      if(currentPage == 11){
        pageNumbers.push(currentPage);
        pageNumbers.push(currentPage+1);
        pageNumbers.push('...');
      } else if(currentPage == lastPage-11){
        pageNumbers.push('...');
        pageNumbers.push(currentPage-1);
        pageNumbers.push(currentPage);
      } else{
        pageNumbers.push('...');
        pageNumbers.push(currentPage-1);
        pageNumbers.push(currentPage);
        pageNumbers.push(currentPage+1);
        pageNumbers.push('...');
      }
    }else{
      pageNumbers.push('...');
    }
    
    for (let i = lastPage - 10; i <= lastPage; i++) {
      if(currentPage==lastPage - 10 && i==lastPage - 10){
        pageNumbers.push(i-1);
        pageNumbers.push(i);
      }
      else{
        pageNumbers.push(i);
      }
    }
  } else {
    for (let i = firstPage; i <= lastPage; i++) {
      pageNumbers.push(i);
    }
  }

  return (
    <div className="col-12" >
      {!loading ? (
        <nav aria-label="Page navigation example">
          <ul className="pagination">
            <li
              className={currentPage <= 1 ? "page-item disabled" : "page-item"}
            >
              <a
                className="page-link"
                href="!#"
                onClick={(e) => {
                  prevPage();
                  window.scrollTo({
                    top: 650,
                    left: 0,
                    behavior: "smooth",
                  });
                  e.preventDefault();
                }}
              >
                Previous
              </a>
            </li>
            {pageNumbers.map((number, index) =>
              number == "..." ? (
                <a className="page-link">...</a>
              ) : (
                <Fragment key={index}>
                  <li
                    key={index}
                    className={
                      number === currentPage ? "page-item active" : "page-item"
                    }
                  >
                    <a
                      onClick={(e) => {
                        paginate(number);
                        e.preventDefault();
                        window.scrollTo({
                          top: 650,
                          left: 0,
                          behavior: "smooth",
                        });
                      }}
                      className="page-link"
                      href="!#"
                    >
                      {number}
                    </a>
                  </li>
                </Fragment>
              )
            )}

            <li
              className={
                currentPage >= pageNumbers.length
                  ? "page-item disabled"
                  : "page-item"
              }
            >
              <a
                className="page-link"
                href="!#"
                onClick={(e) => {
                  nextPage();
                  e.preventDefault();
                  window.scrollTo({
                    top: 650,
                    left: 0,
                    behavior: "smooth",
                  });
                }}
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      ) : (
        ""
      )}
    </div>
  );
};

export default Pagination2;
